import { fieldsAPI } from "./httpCommon";
import { taskAPI } from "./task";

export const postHeadlandGen = async (data) => {
    const res = await fieldsAPI.post('/track_system/generate_headlands', data).then((rs) => (rs.ok ? rs.data : rs.ok))
    return res
}

export const postSegmentationInteractionPoints = async (data) => {
    const res = await fieldsAPI.post('/track_system/segmentation_interaction_points', data).then((rs) => (rs.ok ? rs.data : rs))
    return res
}

export const postSegmentHeadlands = async (data) => {
    const res = await fieldsAPI.post('/track_system/segment_headland', data).then((rs) => (rs.ok ? rs.data : rs.ok))
    return res
}

export const postSegmentLines = async (data) => {
    const res = await fieldsAPI.post('/track_system/segment_lines', data).then((rs) => (rs.ok ? rs.data : rs.ok))
    return res
}

export const postABLinesGen = async (data) => {
    const res = await fieldsAPI.post('/track_system/generate_ab_lines', data).then((rs) => (rs.ok ? rs.data : rs.ok))
    return res
}

export const postGenerateABLinesOptions = async (data) => {
    const res = await fieldsAPI.post('/track_system/generate_ab_lines_options', data).then((rs) => (rs.ok ? rs.data : rs.ok))
    return res
}

export const postSaveFieldWithSurvey = async (formData) => {
    const res = await fieldsAPI.post('/track_system/save_field_with_survey', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        }
    }).then((rs) => (rs.ok ? rs.data : rs))
    return res
}

export const postGenerateABLinesFromDB = async (data) => {
    const res = await fieldsAPI.post('/track_system/generate_ab_lines_from_db', data).then((rs) => (rs.ok ? rs.data : rs.ok))
    return res
}

export const postGenerateABLinesFromShape = async (formData) => {
    const res = await fieldsAPI.post('/track_system/generate_ab_lines_from_shape', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        }
    }).then((rs) => (rs.ok ? rs.data : rs.ok))
    return res
}

export const postExtractCurvedABlines = async (formData) => {
    const res = await fieldsAPI.post('/track_system/extract_ab_lines_from_shape', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        }
    }).then((rs) => (rs.ok ? rs.data : rs.ok))
    return res
}

export const postTrackSystemBorderArrayFromUpload = async (formData) => {
    const res = await fieldsAPI.post('/track_system/border_array_from_upload', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        }
    }).then((rs) => (rs.ok ? rs.data : rs.ok))
    return res
}

export const postCheckBorder = async (data) => {
    const res = await fieldsAPI.post('/track_system/check_border', data).then((rs) => (rs.ok ? rs.data : rs.ok))
    return res
}

export const postCorrectBorder = async (data) => {
    const res = await fieldsAPI.post('/track_system/correct_border', data).then((rs) => (rs.ok ? rs.data : rs.ok))
    return res
}

export const postTrackSystemCutoutsFromUpload = async (formData) => {
    const res = await fieldsAPI.post('/track_system/cutouts_from_upload', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        }
    }).then((rs) => (rs.ok ? rs.data : rs.ok))
    return res
}

export const postGenerateFieldConnection = async (data) => {
    const res = await fieldsAPI.post('/track_system/generate_field_connection', data).then((rs) => (rs.ok ? rs.data : rs))
    return res
}

export const generateROIHeadlands = async(data) => {
    const res = await fieldsAPI.post('/track_system/generate_ROI_headlands', data).then((rs) => (rs.ok ? rs.data : rs))
    return res
}

export const postSaveFieldConnection = async (data) => {
    const res = await taskAPI.post('/newfieldroi', data).then((rs) => (rs.ok ? rs.data : rs.ok))
    return res
}

export const postSaveCutoutHeadlandSegments = async (cutout_id, data) => {
    const res = await taskAPI.post(`/cutout/${cutout_id}/cutoutheadlandsegments`, data).then((rs) => (rs.ok ? rs.data : rs.ok))
    return res
}

export const deleteOldFieldROI = async (field_id, field_roi_id) => {
    const res = await taskAPI.delete(`/field/${field_id}/roi/${field_roi_id}`)
    if (res.status === 204) {
        return true
    }
    return false
}

export const updateOldCutoutHeadlandSegments = async (field_id, field_cutout_headland_segments_id, data) => {
    const res = await taskAPI.put(`/field/${field_id}/cutout-headland-segments/${field_cutout_headland_segments_id}`, data).then((rs) => (rs.ok ? rs.data : rs.ok))
    return res
}

export const updateOldFieldROI = async (field_id, field_roi_id, data) => {
    const res = await taskAPI.put(`/field/${field_id}/roi/${field_roi_id}`, data).then((rs) => (rs.ok ? rs.data : rs.ok))
    return res
}

export const postExtractGeometryFromShape = async (formData) => {
    const res = await fieldsAPI.post('/track_system/extract_geometry_from_shape', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        }
    }).then((rs) => (rs.ok ? rs.data : rs.ok))
    return res
}

export const getFieldROIs = async (field_id) => {
    const res = await taskAPI.get(`/field/${field_id}/roi`).then((rs) => (rs.ok ? rs.data : rs.ok))
    return res
}

export const getFieldCutoutHeadlandSegments = async (field_id) => {
    const res = await taskAPI.get(`/field/${field_id}/cutoutheadlandsegments`).then((rs) => (rs.ok ? rs.data : rs.ok))
    return res
}

export const getFarmROIs = async (farm_id) => {
    const res = await taskAPI.get(`/farm/${farm_id}/allrois`).then((rs) => (rs.ok ? rs.data : rs.ok))
    return res
}

export const getDefaultHeadlandConfig = async (orgId) => {
    const res = await taskAPI.get(`/organization/${orgId}/farms`).then((rs) => (rs.ok ? rs.data : rs.ok))
    return res
}

export const postPathPlanning = async (data) => {
    const res = await fieldsAPI.post('/path_planning/start_planning', data).then((rs) => (rs.ok ? rs.data : rs))
    return res
}

export const getPlanningProgress = async (plannigId) => {
    const res = await fieldsAPI.get(`/path_planning/progress/${plannigId}`).then((rs) => (rs.ok ? rs.data : rs))
    return res
}

export const getPathPlannigRoute = async (plannigId) => {
    const res = await fieldsAPI.get(`/path_planning/route/${plannigId}`).then((rs) => (rs.ok ? rs.data : rs))
    return res
}

export const getPlanningPresetsByTaskType = async (taskType) => {
    const res = await fieldsAPI.get(`/path_planning/planning_presets?task_type=${taskType}`).then((rs) => (rs.ok ? rs.data : rs))
    return res
}

export const postStartEditingPathPlanning = async (data) => {
    const res = await fieldsAPI.post('/path_planning/start_edit', data).then((rs) => (rs.ok ? rs.data : rs))
    return res
}

export const postEditPathSegmentPlanning = async (data) => {
    const res = await fieldsAPI.post('/path_planning/edit_segment', data).then((rs) => (rs.ok ? rs.data : rs))
    return res
}

export const postEditedPathPlanning = async (data) => {
    const res = await fieldsAPI.post('/path_planning/edited_path', data).then((rs) => (rs.ok ? rs.data : rs))
    return res
}

export const postUploadedPathPlanning = async (data) => {
    const res = await fieldsAPI.post('/path_planning/insert_segment_path', data).then((rs) => (rs.ok ? rs.data : rs))
    return res
}

export const getPathPlanningOptions = async () => {
    const res = await fieldsAPI.get('/path_planning/task_types').then((rs) => (rs.ok ? rs.data : rs.ok))
    return res
}

export const postSplitField = async (data) => {
    const res = await fieldsAPI.post('/track_system/split_polygon_with_line', data).then((rs) => (rs.ok ? rs.data : rs))
    return res
}

export const postUploadShapeFileLine = async (formData) => {
    const res = await fieldsAPI.post('/track_system/split_polygon_with_line_from_shape', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        }
    }).then((rs) => (rs.ok ? rs.data : rs.ok))
    return res
}

export const postGetUncoveredArea = async (data) => {
    const res = await fieldsAPI.post('/path_planning/get_uncovered_area', data).then((rs) => (rs.ok ? rs.data : rs))
    return res
}

export const getDefaultEditValues = async () => {
    const res = await fieldsAPI.get('/path_planning/default_edit_values').then((rs) => (rs.ok ? rs.data : rs))
    return res
}